import React from 'react';
import { useTranslation } from 'react-i18next';
import { CircleAlert, CircleCheck, Circle, RefreshCw } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { FlowStatus } from './flowConfigs';

export const FlowStatusIcon: React.FC<{ status: FlowStatus | undefined }> = ({ status }) => {
  switch (status) {
    case 'completed':
      return <CircleCheck className="text-success" />;
    case 'in_progress':
      return <RefreshCw className="animate-spin text-primary" />;
    case 'failed':
      return <CircleAlert className="text-destructive" />;
    default:
      return <Circle className="text-muted-foreground" />;
  }
};

export const FlowStatusBadge: React.FC<{ status: FlowStatus | undefined }> = ({ status }) => {
  const { t } = useTranslation();

  switch (status) {
    case 'completed':
      return <Badge variant="success" className="revy-cjk">{t('drbfm.status.completed')}</Badge>;
    case 'in_progress':
      return <Badge className="revy-cjk">{t('drbfm.status.inProgress')}</Badge>;
    case 'failed':
      return <Badge variant="destructive" className="revy-cjk">{t('drbfm.status.failed')}</Badge>;
    default:
      return <Badge variant="outline" className="revy-cjk">{t('drbfm.status.pending')}</Badge>;
  }
};
